import { IGetEventListRes } from '@reolink-cloud/interface';
import { applyEventListResToStores, applyRequestArgsToStores } from './shared';
import { sendMessageToSW } from '@/utils/sw';
import { swReadyState } from './swReadyState';

/**
 * 把事件列表响应同步到加密元信息 IDB。
 *
 * - **主线程优先**：直接写共享 IDB（与 SW 同源 db/store），保证降级路径可读
 * - **顺带通知 SW**：SW 可用时再 fire-and-forget 把消息发过去（让 SW 内部状态保持同步），
 *   不可用 / 失败也只 warn，不会让业务流程报错
 *
 * 替代旧的 `await sendMessageToSW(res)` —— 旧写法在 SW 不可用时会直接抛错并 reject 上层 Promise。
 */
export const syncEventListToStorage = async ( eventRes: IGetEventListRes ): Promise<void> => {

    await applyEventListResToStores( eventRes );

    if ( swReadyState.isReady ) {

        sendMessageToSW( eventRes ).catch(( error: unknown ) => {

            console.warn( '[mediaStoreSync] notify SW failed, IDB already up to date', error );

        });

    }

};

/**
 * 把当前查询参数写入 IDB（用于 SW NetworkErrorPlugin 上报上下文）。
 */
export const syncRequestArgsToStorage = async ( requestArgs: Record<string, unknown> ): Promise<void> => {

    await applyRequestArgsToStores( requestArgs );

    if ( swReadyState.isReady ) {

        sendMessageToSW({ type: 'getEventListArgs', payload: requestArgs }).catch(( error: unknown ) => {

            console.warn( '[mediaStoreSync] notify SW failed, IDB already up to date', error );

        });

    }

};
